module.exports = __webpack_public_path__ + "img/smiled.d8d6b756.svg";